export default {
  GET_API_KEYS_START: 'GET_API_KEYS_START',
  GET_API_KEYS_SUCCESS: 'GET_API_KEYS_SUCCESS',
  GET_API_KEYS_FAILURE: 'GET_API_KEYS_FAILURE',

  CREATE_API_KEY_START: 'CREATE_API_KEY_START',
  CREATE_API_KEY_SUCCESS: 'CREATE_API_KEY_SUCCESS',
  CREATE_API_KEY_FAILURE: 'CREATE_API_KEY_FAILURE',

  EXTEND_API_KEY_START: 'EXTEND_API_KEY_START',
  EXTEND_API_KEY_SUCCESS: 'EXTEND_API_KEY_SUCCESS',
  EXTEND_API_KEY_FAILURE: 'EXTEND_API_KEY_FAILURE',

  REVOKE_API_KEY_START: 'REVOKE_API_KEY_START',
  REVOKE_API_KEY_SUCCESS: 'REVOKE_API_KEY_SUCCESS',
  REVOKE_API_KEY_FAILURE: 'REVOKE_API_KEY_FAILURE',
};
